import { render, staticRenderFns } from "./File.vue?vue&type=template&id=88317c7e&scoped=true&lang=html&"
import script from "./File.vue?vue&type=script&lang=ts&"
export * from "./File.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88317c7e",
  null
  
)

export default component.exports